// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconDislikePath = 'M4.216 3.783A.993.993 0 0 1 5.192 3h3.812c2.206 0 4 1.795 4 4v2.995L7.636 17a.99.99 0 0 1-.78-.398.985.985 0 0 1-.161-.876L8.33 10H2.834l1.382-6.217ZM17.004 10h-2V7a5.971 5.971 0 0 0-1.54-4h3.54v7ZM5.678 12l-.907 3.176a2.98 2.98 0 0 0 .489 2.631A2.976 2.976 0 0 0 7.655 19h.967l5.382-7.023V12h5V1H5.192a2.982 2.982 0 0 0-2.93 2.35L.34 12h5.338Z';
var IconDislike = baseIcon('IconDislike', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconDislikePath
});
export default IconDislike;
//# sourceMappingURL=index.js.map